export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8160.173f61fc.jpg";